export default __webpack_public_path__ + "static/media/viewMorePlainIcon.872bd72c.svg";